import React, { useContext } from "react";

import { ApplicationContext, SuppressForNative } from "@swa-ui/application";
import { DesktopHeaderControl, DotcomHeader, MobileHeaderControl } from "@swa-ui/dotcom";

import { useNavigationType } from "../../hooks/useNavigationType";
import styles from "./LandingPageHeader.module.scss";

/**
 * LandingPageHeader will render the header for static html pages.
 */

export const LandingPageHeader = (props) => {
  const { light, menuItemSeparator, uppercaseMenuItems } = props;
  const { persona, site } = useContext(ApplicationContext);
  const navigationType = useNavigationType();

  return (
    <header className={styles.header}>
      <SuppressForNative>
        <DotcomHeader {...getHeaderProps()} />
      </SuppressForNative>
    </header>
  );

  function getHeaderProps() {
    const control =
      navigationType === "desktop" ? (
        <DesktopHeaderControl light={light} />
      ) : (
        <MobileHeaderControl site={site} />
      );

    return {
      appHeader: null,
      control,
      light,
      menuItemSeparator,
      pageTitle: "",
      persona,
      type: navigationType,
      uppercaseMenuItems,
      waitForContent: false,
    };
  }
};
